import React from 'react';
import { useNavigate } from 'react-router-dom';
import cloudimalogo from '../assets/images/cloudima_png-01.png';

const ThankYou = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        navigate('/');
    };

    return (
        <div className="thank-you-page bg-gradient-to-r from-white to-indigo-500 min-h-screen flex items-center justify-center p-4">
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center">
                <img
                    src={cloudimalogo}
                    alt="Cloudima Logo"
                    className="opacity-85 w-40 md:w-30 lg:w-40 rounded-full mx-auto mb-6"
                />
                <h1 className="text-3xl font-bold text-gray-800 mb-4">Thank You!</h1>
                <p className="text-gray-700 mb-6">
                    Your request has been submitted successfully. We’ll get back to you shortly!<br/>
                    <span className="text-sm text-gray-500">If you do not see our email soon, please check your spam or junk folder.</span>
                </p>
                <button
                    onClick={handleReturnHome}
                    className="bg-indigo-500 text-white px-6 py-2 rounded-lg hover:bg-indigo-600 transition-colors duration-300"
                >
                    Return to Home
                </button>
            </div>
        </div>
    );
};

export default ThankYou;
